import { render, staticRenderFns } from "./CreateAttribute.vue?vue&type=template&id=0d4800e0"
import script from "./CreateAttribute.vue?vue&type=script&lang=js"
export * from "./CreateAttribute.vue?vue&type=script&lang=js"
import style0 from "./CreateAttribute.vue?vue&type=style&index=0&id=0d4800e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports